<template>
  <!-- 予約編集/追加 -->
  <div id="AppAppointmentEditContents" :status="status">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div style="margin-left: 50px; margin-Right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">
            予約
            <span v-if="status==4 && !editFlg">追加</span>
            <span v-if="editFlg">参照</span>
            <span v-else>編集</span>
          </label>
        </div>
      </div>
    </div>
    <div style="margin-left: 50px; margin-Right: 50px;">
      <!-- 詳細表示 -->
      <div style="detailArea">
        <div>
          <div style="height:10px;"></div>
          <table class="table is-full">
            <table style="width: 100%;">
              <tr>
                <th style="border-bottom: solid 1px; width: 200px;">予約番号</th>
                <td style="border-bottom: solid 1px;" colspan="2">{{ data.reservationId }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">点検予定日</th>
                <td style="border-bottom: solid 1px;" colspan="2">
                  <b-field
                    v-if="status!=6  && status!=5 && !isCrossBorder && !editFlg"
                    :type="{'is-danger':errors.has('scheduledDay')}"
                    :message="errors.first('scheduledDay')"
                  >
                    <b-datepicker
                      name="scheduledDay"
                      v-model="scheduledDay"
                      placeholder="select a date.."
                      data-vv-as="点検予定日"
                      data-vv-validate-on="input"
                      v-validate="`${crossBorderCofficeTar && status==4 ? '' : 'required'}`"
                      icon="calendar-today"
                      :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                      :day-names="['日','月','火','水','木','金','土']"
                    ></b-datepicker>
                  </b-field>
                  <span v-else>{{data.scheduledDay}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">点検予定時刻</th>
                <td style="border-bottom: solid 1px;" colspan="2">
                  <b-field
                    v-if="status!=6  && status!=5 && !isCrossBorder && !editFlg"
                    :type="{'is-danger':errors.has('scheduledTime')}"
                    :message="errors.first('scheduledTime')"
                  >
                    <b-timepicker
                      name="scheduledTime"
                      v-model="scheduledTime"
                      v-validate="`${crossBorderCofficeTar && status==4 ? '' : 'required'}`"
                      placeholder="Type or select a date..."
                      data-vv-validate-on="input"
                      data-vv-as="点検予定時刻"
                      icon="clock"
                    ></b-timepicker>
                  </b-field>
                  <span v-else>{{data.scheduledTime}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px; border: 0px none;">点検担当者</th>
                <td style="border-bottom: solid 1px; border: 0px none;" colspan="2">
                  <b-field
                    v-if="status!=6  && status!=5 && !isCrossBorder && !editFlg"
                    :type="{'is-danger':errors.has('staffName')}"
                    :message="errors.first('staffName')"
                  >
                    <b-input
                      v-model="data.staffName"
                      :readonly="true"
                      v-validate="`${crossBorderCofficeTar && status==4 ? '' : 'required'}`"
                      data-vv-as="点検担当者"
                      name="staffName"
                      style="width: 100%;"
                    ></b-input>
                    <b-button
                      style="float:right; bottom:0;"
                      class="button is-primary has-text-centered"
                      icon-left="account-switch"
                      native-type="button"
                      v-on:click="changeStaff"
                    ></b-button>
                    <b-modal
                      v-if="crossBorderCofficeTar == ''"
                      :active.sync="isSupportStaffChangeActive"
                      has-modal-card
                    >
                      <staffChange-modal
                        v-bind:office-master-list="referenceEnableOfficeList"
                        v-on:staff-change-event="staffChanged"
                      ></staffChange-modal>
                    </b-modal>
                    <b-modal v-else :active.sync="isSupportStaffChangeActive" has-modal-card>
                      <staffChange-modal
                        v-bind:office-code="officeCode"
                        v-on:staff-change-event="staffChanged"
                      ></staffChange-modal>
                    </b-modal>
                  </b-field>
                  <span v-else>{{data.staffName}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">所属営業所</th>
                <td style="border-bottom: solid 1px;" colspan="2">
                  <span>{{srcStaffOffice|officeFilter(officeMaster)}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">越境依頼元</th>
                <td style="border-bottom: solid 1px;" colspan="2">
                  <b-select
                    v-if="crossBorderCofficeSrcList && crossBorderCofficeSrcList.length > 1 && status!=5 && status!=6"
                    expanded
                    v-model="crossBorderCofficeSrc"
                  >
                    <option
                      v-for="ofiiceSrc in crossBorderCofficeSrcList"
                      :value="ofiiceSrc"
                      :key="ofiiceSrc.id"
                    >{{ ofiiceSrc|officeFilter(officeMaster)}}</option>
                  </b-select>
                  <span v-else>{{crossBorderCofficeSrc|officeFilter(officeMaster)}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">越境依頼先</th>
                <td style="border-bottom: solid 1px;" colspan="2">
                  <b-select v-if="status == 4 && !editFlg" expanded v-model="crossBorderCofficeTar">
                    <option
                      v-for="office in crossBorderCofficeList"
                      :value="office.officeCode"
                      :key="office.officeCode"
                    >{{ office.officeName }}</option>
                  </b-select>
                  <span v-else>{{crossBorderCofficeTar|officeFilter(officeMaster)}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">実施状況</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="2"
                  v-if="(status==4 && !editFlg) || (status==1 && !isCrossBorder && !editFlg)"
                >
                  <b-field
                    :type="{'is-danger':errors.has('appointmentStatus')}"
                    :message="errors.first('appointmentStatus')"
                  >
                    <b-select
                      xpanded="true"
                      v-model="data.status"
                      name="appointmentStatus"
                      data-vv-as="実施状況"
                      v-validate="'required|selectRange:1:2'"
                    >
                      <option value="1">アポ未実施</option>
                      <option value="2">アポ実施済</option>
                    </b-select>
                  </b-field>
                </td>
                <td style="border-bottom: solid 1px;" colspan="2" v-else>
                  <span v-if="data.status==6">点検完了</span>
                  <span v-else-if="data.status==1">アポ未実施</span>
                  <span v-else-if="data.status==2">アポ実施済</span>
                  <span v-else-if="data.status==3">点検中</span>
                  <span v-else-if="data.status==5">取り消し</span>
                </td>
              </tr>
              <template v-for="(patient, index) in data.patients">
                <tr :key="'patient' + index + '_1'">
                  <th style="border-bottom: solid 1px;" rowspan="4">{{"患者情報" + (index + 1)}}</th>
                  <th style="border-bottom: solid 1px; width:150px">患者名</th>
                  <td style="border-bottom: solid 1px;">{{ patient.patientName }}</td>
                </tr>
                <tr :key="'patient' + index + '_2'">
                  <th style="border-bottom: solid 1px;">住所</th>
                  <td
                    style="border-bottom: solid 1px;"
                  >〒{{patient.patientZipCode}} {{ patient.patientAddress }}</td>
                </tr>
                <tr :key="'patient' + index + '_3'">
                  <th style="border-bottom: solid 1px;">電話番号</th>
                  <td style="border-bottom: solid 1px;">{{ patient.patientPhone }}</td>
                </tr>
                <tr :key="'patient' + index + '_4'">
                  <th style="border-bottom: solid 1px;">点検対象機器</th>
                  <td style="border-bottom: solid 1px;">
                    <b-field
                      class="column"
                      grouped
                      group-multiline
                      :type="{'is-danger':errors.has('inspectionKind' + index)}"
                      :message="errors.first('inspectionKind' + index)"
                    >
                      <div v-for="(product, productIndex) in patient.products" v-bind:key="productIndex">
                        <b-checkbox
                          :disabled="status!=4"
                          v-model="product.inspectionKind"
                          :name="'inspectionKind' + index" 
                          data-vv-validate-on="input"
                          v-validate="'hasInspectionKind' + index + ':' + index"
                        >{{product.productName}}</b-checkbox>
                      </div>
                    </b-field>
                  </td>
                </tr>
              </template>
              <tr>
                <th style="border-bottom: solid 1px;">メモ</th>
                <td style="border-bottom: solid 1px;" colspan="2">
                  <b-field
                    :type="{'is-danger':errors.has('appointmentComment')}"
                    :message="errors.first('appointmentComment')"
                  >
                    <b-input
                      type="textarea"
                      v-model="data.appointmentComment"
                      :readonly="status==6 || status==5 || editFlg"
                      name="appointmentComment"
                      data-vv-as="メモ"
                      v-validate="'max:256'"
                      maxlength="256"
                    ></b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">点検実施住所</th>
                <td style="border-bottom: solid 1px;" colspan="2">
                  <b-field
                    :type="{'is-danger':errors.has('inspectionAddress')}"
                    :message="errors.first('inspectionAddress')"
                  >
                    <b-input
                      :readonly="status==5 || status==6 ||isCrossBorder || editFlg"
                      v-model="data.inspectionAddress"
                      name="inspectionAddress"
                      data-vv-as="点検実施住所"
                      v-validate="'required|max:256'"
                      maxlength="256"
                    ></b-input>
                  </b-field>
                </td>
              </tr>
              <tr v-if="status==6">
                <!-- 点検完了時には点検外作業内容を表示する -->
                <th style="border-bottom: solid 1px;">点検外作業内容</th>
                <td style="border-bottom: solid 1px;" colspan="2">
                  <b-field>
                    <b-input type="textarea" v-model="data.otherWork" :readonly="true"></b-input>
                  </b-field>
                </td>
              </tr>
            </table>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StaffSearchTemplate from "./AppSelectStaff";
import * as inspection from "../utils/inspection";

const StaffChangeModalForm = {
  props: ["officeCode", "officeMasterList"],
  components: {
    staffSearch: StaffSearchTemplate
  },
  methods: {
    save: function(event) {
      // 選択されている担当者を取得
      var staffInfo = this.$refs.staffList.getStaff();
      this.staffCode = staffInfo.staffCode;
      this.staffName = staffInfo.lastName + staffInfo.firstName;
      var newStaffoffice = staffInfo.officeCode;
      this.setStaffs(
        this.officeCode,
        this.staffCode,
        this.staffName,
        newStaffoffice
      );
    },
    setStaffs: function(officeCode, staffCode, staffName, newStaffoffice) {
      // 選択された担当者情報を親画面に返却
      this.$emit(
        "staff-change-event",
        officeCode,
        staffCode,
        staffName,
        newStaffoffice
      );
      this.$parent.close();
    }
  },
  data() {
    var office = this.$props.officeCode;
    var referenceEnableOfficeList = this.$props.officeMasterList;
    return {
      office,
      referenceEnableOfficeList
    };
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 800px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">対応者選択</p>
            </header>
            <section class="modal-card-body">
              <staffSearch ref="staffList" v-bind:office-code="office" v-bind:office-master-list="referenceEnableOfficeList" />
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="save">決定</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
            </footer>
          </div>
        </form>
      `
};

export default {
  name: "AppAppointmentEditContents",
  methods: {
    checkstaff: function() {
      if (this.data.staffName) {
        // エラーリセット
        this.errors.remove("staffName");
      }
    },
    staffChanged: function(officeCode, staffCode, staffName, newStaffoffice) {
      // 選択された担当者情報をモーダル画面から取得
      // 画面に変更内容を反映
      this.data.staffCode = staffCode;
      this.data.staffName = staffName;
      this.srcStaffOffice = newStaffoffice;
      this.checkstaff();
    },
    changeStaff: function(event) {
      this.isSupportStaffChangeActive = true;
    },
    getOfficeName: function(value) {
      var officeElement = this.officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
    save: function() {
      var excuteApi = this.setAppointmentPOST;
      var successCallBack = this.setAppointmentPOSTSuccess;
      var errorCallBack = this.setAppointmentPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    cancel: function() {
      this.data.status = 5;
      var excuteApi = this.setAppointmentPOST;
      var successCallBack = this.setAppointmentPOSTSuccess;
      var errorCallBack = this.setAppointmentPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },

    setAppointmentPOST: function(client) {
      var body = {};
      if (!this.data.appointmentComment) {
        this.data.appointmentComment = "";
      }
      this.data.crossBorderCofficeSrc = this.getOfficeName(
        this.data.crossBorderCofficeSrcCode
      );
      if (!this.data.crossBorderCofficeTarCode) {
        this.data.crossBorderCofficeTarCode = "";
        this.data.crossBorderCofficeTar = "";
      } else {
        this.data.crossBorderCofficeTar = this.getOfficeName(
          this.data.crossBorderCofficeTarCode
        );
      }
      if (
        this.data.status == "1" &&
        this.data.scheduledDay &&
        this.data.scheduledTime
      ) {
        this.data.status = 2;
      }
      this.data.status = parseInt(this.data.status);
      for (var key in this.data) {
        body[key] = this.data[key];
      }

      const patients = [];
      if (this.data.patients && this.data.patients.length > 1) {
        // 一括点検
        for (const patient of this.data.patients) {
          const _pathient = {
            reservationId: patient.reservationId,
            patientCode: patient.patientCode,
            patientName: patient.patientName,
            patientZipCode: patient.patientZipCode,
            patientAddress: patient.patientAddress,
            patientPhone: patient.patientPhone,
            productList: patient.products
          };
          patients.push(_pathient);
        }
      } else {
        // 単一点検
        body.patientCode = this.data.patients[0].patientCode;
        body.patientName = this.data.patients[0].patientName;
        body.patientZipCode = this.data.patients[0].patientZipCode;
        body.patientAddress = this.data.patients[0].patientAddress;
        body.patientPhone = this.data.patients[0].patientPhone;
        body.productList = this.data.patients[0].products;
        body.isDealer = this.data.inspectionType == inspection.INSPECTION_TYPE_MAP.homeDealer.code;
      }
      body.patients = patients;

      return client.apis.apiAppointment.setAppointmentPOST({
        body: body
      });
    },
    setAppointmentPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.successEndFlg = true;
    },
    setAppointmentPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getAppointmentPOST: function(client) {
      return client.apis.apiAppointment.getAppointmentPOST({
        body: {
          appointmentCode: this.appointmentCode
        }
      });
    },
    getAppointmentPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      this.crossBorderCofficeSrc = this.data.crossBorderCofficeSrcCode;
      this.crossBorderCofficeSrcList = this.data.crossBorderCofficeSrcList;
      this.officeCode = this.data.crossBorderCofficeSrcCode;
      this.srcStaffCode = this.data.staffCode;
      this.srcStaffName = this.data.staffName;
      this.staffName = this.data.staffName;
      this.status = this.data.status;
      this.srcStaffOffice = this.data.staffOfficeCode;
      this.flg = true;
      if (this.data.crossBorderCofficeTarCode) {
        this.officeCode = this.data.crossBorderCofficeTarCode;
        this.crossBorderCofficeTar = this.data.crossBorderCofficeTarCode;
      }
      // 文字列⇒Date型変換処理(点検予定日,点検時刻)
      if (this.data.scheduledDay && this.data.scheduledDay != "") {
        this.scheduledDay = this.parseDate(this.data.scheduledDay);
      } else {
        this.data.scheduledDay = null;
        this.scheduledDay = null;
      }

      if (this.data.scheduledTime && this.data.scheduledTime != "") {
        this.scheduledTime = this.parseTime(this.data.scheduledTime);
      } else {
        this.data.scheduledTime = null;
        this.scheduledTime = null;
      }

      // 単一点検の場合、画面表示用に患者の配列化
      if (!this.data.patients.length) {
        const patient = {
          patientName: this.data.patientName,
          patientCode: this.data.patientCode,
          patientZipCode: this.data.patientZipCode,
          patientAddress: this.data.patientAddress,
          patientPhone: this.data.patientPhone,
          status: this.data.status,
          products: this.data.productList
        };
        this.data.patients = [patient];
      }

      this.addValidator(this.data);
    },
    getAppointmentPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    isSuccessEnd: function() {
      return this.successEndFlg;
    },
    check: async function(isDelete) {
      var result = await this.$validator.validateAll();
      if (isDelete) {
        // 予約取消しの場合、バリデーションは無視させる
        this.$validator.errors.remove("scheduledDay");
        this.$validator.errors.remove("scheduledTime");
        this.$validator.errors.remove("staffName");
      } else if (
        this.data.crossBorderCofficeSrcCode ==
        this.data.crossBorderCofficeTarCode
      ) {
        this.showErrorMessage(
          "越境依頼元と越境依頼先が同じ営業所になっています。"
        );
        return false;
      }
      return this.$validator.errors.items.length == 0;
    },
    addValidator: function(data) {
      for (let i = 0; i < data.patients.length; ++i) {
        this.$validator.extend("hasInspectionKind" + i, {
          getMessage: field => `点検対象機器を選択してください。`,
          validate: (value, { index }) => {
            if (this.status != 4) {
              // 予約追加で無ければ編集不可の為、バリデーション無視
              return true;
            }
            var ret = false;
            for (const product of this.data.patients[index].products) {
              if (product.inspectionKind) {
                ret = true;
                break;
              }
            }
            return ret;
          }
        },
        {
          paramNames: [ "index" ],
        }
        );
      }
      return;
    }
  },
  data() {
    var data = {};
    var officeCode = "";
    var crossBorderCofficeSrc = "";
    var crossBorderCofficeTar = "";
    var staffName = "";
    var srcStaffCode = "";
    var srcStaffName = "";
    var flg = false;
    var status = this.$route.params["status"];
    var appointmentCode = this.$route.params["appointmentCode"];
    var isCrossBorder = this.$route.params["isCrossBorder"];
    var editFlg = this.$route.params["editFlg"];
    var roleId = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
    if (status !== "4") {
      // データ取得
      var excuteApi = this.getAppointmentPOST;
      var successCallBack = this.getAppointmentPOSTSuccess;
      var errorCallBack = this.getAppointmentPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    } else {
      // 予約追加の場合は、渡されたデータを表示
      srcStaffCode = JSON.parse(sessionStorage.getItem("userInfo")).staffCode;
      srcStaffName = JSON.parse(sessionStorage.getItem("userInfo")).fullName;
      var crossBorderCofficeSrcList = this.$route.params["sloffs"];
      var srcStaffOffice = JSON.parse(sessionStorage.getItem("userInfo"))
        .officeCode;
      staffName = srcStaffName;

      data.crossBorderCofficeSrcCode = crossBorderCofficeSrcList[0];
      officeCode = crossBorderCofficeSrcList[0];
      crossBorderCofficeSrc = crossBorderCofficeSrcList[0];

      data.staffName = staffName;
      data.staffCode = srcStaffCode;
      data.patients = this.$route.params.patients;
      
      for (const patient of data.patients) {
        for (const product of patient.products) {
          product.inspectionKind = true;
        }
      }

      if (!this.$route.params.hospitalAddress) {
        data.inspectionAddress = this.$route.params.patients[0].patientAddress;
      } else {
        data.inspectionAddress = this.$route.params.hospitalAddress;
      }
      data.status = 1; //アポ未実施
      this.addValidator(data);
    }

    var referenceEnableOfficeList = JSON.parse(
      sessionStorage.getItem("referenceEnableOffice")
    );

    var officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    // 越境依頼先リスト
    var crossBorderCofficeList = JSON.parse(
      sessionStorage.getItem("officeMaster")
    );
    // 未選択状態の追加
    crossBorderCofficeList.unshift({
      officeCode: "",
      officeName: "",
      phoneNumber: ""
    });

    return {
      data,
      isCrossBorder,
      officeMaster,
      referenceEnableOfficeList,
      crossBorderCofficeList,
      status,
      officeCode,
      crossBorderCofficeSrc,
      crossBorderCofficeTar,
      staffName,
      appointmentCode,
      scheduledDay: null,
      scheduledTime: null,
      successEndFlg: false,
      isSupportStaffChangeActive: false,
      srcStaffCode,
      srcStaffName,
      flg,
      roleId,
      editFlg,
      crossBorderCofficeSrcList,
      srcStaffOffice,
    };
  },
  watch: {
    scheduledDay(value) {
      this.data.scheduledDay = this.formatDate(value);
    },
    scheduledTime(value) {
      this.data.scheduledTime = this.formatTime(value);
    },
    crossBorderCofficeTar(value) {
      if (value) {
        this.officeCode = value;
      } else {
        this.officeCode = this.crossBorderCofficeSrc;
      }
      this.data.crossBorderCofficeTarCode = value;
      this.data.crossBorderCofficeTar = this.getOfficeName(value);
      if (this.status == 4) {
        this.data.staffCode = "";
        this.data.staffName = "";
      }
    },
    crossBorderCofficeSrc(value) {
      if (this.crossBorderCofficeTar == "") {
        this.officeCode = value;
      }
      this.data.crossBorderCofficeSrcCode = value;
      this.data.crossBorderCofficeSrc = this.getOfficeName(value);
      // if (this.status == 4) {
      //   this.data.staffCode = "";
      //   this.data.staffName = "";
      // }
    },
  },
  components: { "staffChange-modal": StaffChangeModalForm },
  mounted: function() {},
  created: function() {},
  filters: {
    officeFilter: function(value, officeMaster) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppAppointmentEditContents.vue